import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import Cleave from 'vue-cleave-component'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.use(Cleave)

// info global değişkenler
Vue.prototype.priceStep = 0.0001
